import { createSelector } from 'reselect';

const news = (state: any) => state.get('news');
export const newsSelector = createSelector([news], (newsData: any) => newsData.toJS());
